var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length
    ? _c("div", { staticClass: "home-banner", attrs: { id: "scrollDIV" } }, [
        _c("div", { staticClass: "swiper-container" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper swiper-wrapper-holder" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "swiper-slide home-banner-img",
                  attrs: {
                    href: item.link,
                    uigs: "out_home_big_video_" + index,
                    "data-report": JSON.stringify({
                      home_banner_click: _vm.list[_vm.activeIndex].title,
                    }),
                  },
                },
                [
                  _c("img-item", {
                    attrs: {
                      src: item.img_url,
                      lazy: index === 0 ? false : true,
                    },
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(item.name))]),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.list.length > 1
          ? _c(
              "div",
              { staticClass: "home-banner-btn" },
              _vm._l(_vm.list, function (item, index) {
                return _c("span", { key: index, class: { cur: index === 0 } })
              }),
              0
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }